import React from "react"

import { SbCard } from "components/commons"

import { EconomicCardInfo } from "./models"

export interface EconomicCardProps
{
    cardType: EconomicCardInfo
    value?: number | string
    customFooter?: React.ReactElement
}
export interface EconomicCardState
{
}
export class EconomicCard extends React.Component<EconomicCardProps, EconomicCardState>
{
    private calculateValue = () => {
        if(this.props.value === undefined) {
            return "-"
        }

        if(typeof this.props.value === "number") {
            return this.props.value
                .toFixed(2)
                .replace(/\.00/g, "")
                .replace(/\./g, ",")
        } else {
            return this.props.value
        }
    }

    render()
    {
        let { cardType } = this.props

        return (
            <SbCard
                avatarIcon={cardType.avatarIcon}
                backgroundImage={cardType.background}
                avatarBackgroundColour={cardType.avatarColour}
                title={cardType.title}
                mainValue={this.calculateValue()}
            />
        )

        // return (
        //     <Paper
        //         elevation={0}
        //         sx={{
        //             height: "150px",
        //             px: 2,
        //             py: 2,
        //             position: "relative",
        //             backgroundImage: `url(${cardType.background})`,
        //             backgroundSize: "160% 100%",
        //             backgroundPosition: "0% 50%",
        //             cursor: "pointer",
        //         }}>
        //         <Stack direction="column" spacing={3} sx={{mt:2}}>
        //             <Typography sx={{ color: 'white', fontSize: 17 }}>
        //                 {cardType.title}
        //             </Typography>
        //             <Typography sx={{ color: 'white', fontWeight: 'medium', fontSize: 28 }}>
        //                 {this.calculateValue()}
        //             </Typography>
        //         </Stack>
        //         <div style={{
        //             position: "absolute",
        //             right: "16px",
        //             top: "16px",
        //         }}>
        //             <Avatar sx={{
        //                 backgroundColor: cardType.avatarColour,
        //                 width: 64,
        //                 height: 64,
        //             }}>
        //                 <SvgIcon component={cardType.avatarIcon} sx={{ fontSize: 40 }} />
        //             </Avatar>
        //         </div>
        //     </Paper>
        // )
    }
}
